module.exports = __webpack_public_path__ + "static/media/Ally_app_4.bc3597f1.jpg";